import React, { useState } from 'react';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import AddCapteurComposante from '../../Capteur/Ajouter/AddCapteurComposante';
import Bouton from '../../UI/Bouton/Bouton';
import FormulaireSelectionEmailgroup from './FormulaireSelectionEmailgroup/FormulaireSelectionEmailgroup';
import FormulaireSelectionImportFilter from './FormulaireSelectionImportFilter/FormulaireSelectionImportFilter';
import FormulaireSelectionProjet from './FormulaireSelectionProjet/FormulaireSelectionProjet';
import FormulaireSelectionSensorType from './FormulaireSelectionSensorType/FormulaireSelectionSensorType';
import { stringOrEmptyString } from '../../../ressources/functionJS/stringOrEmptyString';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import { MdClose, MdDone } from 'react-icons/md';
import { glossaire_time_zone } from '../../../ressources/glossaires/glossaire_time_zones';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import profilStyles from '../ProfilCapteur/ProfilCapteur.module.scss';
import S from './AjouterCapteur.module.scss';
import MessageErreur, {
  classeChampEnErreur,
} from '../../UI/MessageErreur/MessageErreur';
import { schemaNouveauCapteur } from '../../../services/schemas/capteur';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../services/schemas/validerFormulaire';

const valeurParDefaut = {
  project_id: null,
  type_id: null,
  sensor_name: '',
  sensors_group: '',
  remarks: '',
  format_date: '',
  path_ascii_file: '',
  position: null,
  import_filter_id: null,
  emailgroup_id: null,
  active: 1,
  sensor_projection: 1,
  coordinate_x: null,
  coordinate_y: null,
  coordinate_z: null,
  time_zone: 'Europe/Paris',
  watchdog: null,
  criticite_id: 0,
  component_list: [],
};

const Ajouter = (props) => {
  const [formAddSensor, setFormAddSensor] = useState({
    ...valeurParDefaut,
  });
  const [erreurs, setErreurs] = useState({});
  const gererEtatDeCibleName = (event) => {
    const { name, value } = event.target;
    setFormAddSensor((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const gererComposantes = (component_list) => {
    setFormAddSensor((prevState) => ({
      ...prevState,
      component_list,
    }));
  };

  const gererTypeId = (typeId) => {
    setFormAddSensor((prevState) => ({
      ...prevState,
      type_id: typeId,
    }));
  };

  const gererEmailgroupId = (emailgroupId) => {
    setFormAddSensor((prevState) => ({
      ...prevState,
      emailgroup_id: emailgroupId,
    }));
  };

  const gererImportFilterId = (importFilterId) => {
    setFormAddSensor((prevState) => ({
      ...prevState,
      import_filter_id: importFilterId,
    }));
  };

  const gererProjetId = (projetId) => {
    setFormAddSensor((prevState) => ({
      ...prevState,
      project_id: projetId,
    }));
  };

  const gererEnvoi = () => {
    // Valeurs brutes : la conversion numérique est faite par le schéma, qui
    // peut ainsi distinguer un champ vide d'une saisie illisible. Un
    // parseFloat appliqué ici produirait NaN dans les deux cas.
    const formulaireCreerCapteur = {
      project_id: formAddSensor.project_id,
      type_id: formAddSensor.type_id,
      sensor_name: stringOrEmptyString(formAddSensor.sensor_name),
      sensors_group: stringOrEmptyString(formAddSensor.sensors_group),
      remarks: stringOrEmptyString(formAddSensor.remarks),
      format_date: stringOrEmptyString(formAddSensor.format_date),
      path_ascii_file: stringOrEmptyString(formAddSensor.path_ascii_file),
      position: stringOrEmptyString(formAddSensor.position),
      import_filter_id: formAddSensor.import_filter_id,
      emailgroup_id: formAddSensor.emailgroup_id,
      active: formAddSensor.active,
      sensor_projection: formAddSensor.sensor_projection,
      coordinate_x: formAddSensor.coordinate_x,
      coordinate_y: formAddSensor.coordinate_y,
      coordinate_z: formAddSensor.coordinate_z,
      time_zone: formAddSensor.time_zone,
      watchdog: formAddSensor.watchdog,
      criticite_id: formAddSensor.criticite_id,
      component_list: formAddSensor.component_list,
    };

    const { valide, donnees, erreurs: erreursValidation } = validerFormulaire(
      schemaNouveauCapteur,
      formulaireCreerCapteur
    );
    setErreurs(erreursValidation);
    if (!valide) {
      return;
    }

    props.ajouter(donnees);
  };

  return (
    <>
      <div className={[S.ConteneurInfo].join(' ')}>
        <div
          className={[s.container, s.text_left, S.Formulaire, S.newSlil].join(' ')}
        >
          <div className={s.row}>
            <div className={[s.col_md_8, s.text_left].join(' ')}>
              <div className={profilStyles.text_profil}>
                {/*Formulaire pour sélectionner un projet*/}
                <FormulaireSelectionProjet gererProjetId={gererProjetId} />
                {/*Formulaire pour sélectionner un type de capteur*/}
                <FormulaireSelectionSensorType
                  gererSensorTypeId={gererTypeId}
                />
                {/*Formulaire pour le nom du capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('nom')}{' '}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="sensor_name"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'sensor_name') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.sensor_name}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'sensor_name')} />
                {/*Formulaire pour le groupe de capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('groupe_de_capteurs')}{' '}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="sensors_group"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'sensors_group') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.sensors_group}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'sensors_group')} />
                {/*Formulaire pour les remarques sur le capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('remarques')}{' '}
                </label>
                <textarea
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="remarks"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'remarks') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.remarks}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'remarks')} />
                {/*Formulaire de sélection du format de date*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('format_date')}{' '}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="format_date"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'format_date') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.format_date}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'format_date')} />
                {/*Formulaire du chemin du fichier ascii du capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('chemin_fichier_ascii')}{' '}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="path_ascii_file"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'path_ascii_file') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.path_ascii_file}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'path_ascii_file')} />
                {/*Formulaire de la position du capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('position')}
                </label>
                <textarea
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="position"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'position') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.position}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'position')} />
                {/*Formulaire pour de l'id du filtre d'importation*/}
                <FormulaireSelectionImportFilter
                  gererImportFilterId={gererImportFilterId}
                />
                {/*Formulaire pour de l'id du groupe d'email de capteur*/}
                <FormulaireSelectionEmailgroup
                  gererEmailgroupId={gererEmailgroupId}
                />
                {/*Formulaire de active/desactive capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('activite_au_capteur')}
                </label>
                <select
                  value={formAddSensor.active}
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="active"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'active') ? classeChampEnErreur : '',
                  ].join(' ')}
                >
                  <option selected={formAddSensor.active} value={1}>
                    active
                  </option>
                  <option selected={!formAddSensor.active} value={0}>
                    desactive
                  </option>
                </select>
                <MessageErreur cle={messageDuChamp(erreurs, 'active')} />

                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('repere_du_capteur')}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="sensor_projection"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'sensor_projection') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.sensor_projection}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'sensor_projection')} />
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('coordonnee_x')}
                </label>
                <textarea
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="coordinate_x"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'coordinate_x') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.coordinate_x}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'coordinate_x')} />
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('coordonnee_y')}
                </label>
                <textarea
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="coordinate_y"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'coordinate_y') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.coordinate_y}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'coordinate_y')} />
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('coordonnee_z')}
                </label>
                <textarea
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="coordinate_z"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'coordinate_z') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.coordinate_z}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'coordinate_z')} />

                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('time_zone')}
                </label>

                <input
                  list="timezones"
                  value={formAddSensor.time_zone}
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="time_zone"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'time_zone') ? classeChampEnErreur : '',
                  ].join(' ')}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'time_zone')} />

                <datalist id="timezones">
                  <option disabled={true} selected={true}>
                    Selecione um fuso horário
                  </option>
                  {glossaire_time_zone.map((timezone) => (
                    <option
                      value={timezone}
                      selected={formAddSensor.time_zone === timezone}
                    >
                      {timezone}
                    </option>
                  ))}
                </datalist>
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('watchdog')} {checkMot('(en minutes)')}{' '}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="watchdog"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'watchdog') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.watchdog}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'watchdog')} />
                {/*Formulaire du chemin du fichier ascii du capteur*/}
                <label className={[S.taglabel, s.card_header].join(' ')}>
                  {checkMot('criticite_id')}{' '}
                </label>
                <input
                  onChange={(event) => gererEtatDeCibleName(event)}
                  name="criticite_id"
                  className={[
                    profilStyles.text_general,
                    messageDuChamp(erreurs, 'criticite_id') ? classeChampEnErreur : '',
                  ].join(' ')}
                  value={formAddSensor.criticite_id}
                />
                <MessageErreur cle={messageDuChamp(erreurs, 'criticite_id')} />
              </div>
            </div>
          </div>
          {/*Bouton ajouter une composante */}
          <AddCapteurComposante gererComposantes={gererComposantes} />
          <div className={s.row}>
            {/*Bouton annuler*/}
            <div className={s.col_6}>
              <Bouton cliquer={(event) => props.annuler(event)}>
                <MdClose />
                {checkMot('annuler')}
              </Bouton>
            </div>
            <div className={s.col_6}>
              {/*Requête créer un capteur*/}
              <AttenteRequete
                request_type={requestType.creation_d_un_capteur}
                str={checkMot('creation_en_cour')}
              >
                <Bouton cliquer={gererEnvoi}>
                  <MdDone />
                  {checkMot('creer')}
                </Bouton>
              </AttenteRequete>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ajouter;
